import { render, staticRenderFns } from "./dui-tab.vue?vue&type=template&id=645572c1&"
import script from "./dui-tab.vue?vue&type=script&lang=js&"
export * from "./dui-tab.vue?vue&type=script&lang=js&"
import style0 from "./dui-tab.vue?vue&type=style&index=0&id=645572c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports